import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { TypeTacheService } from '../../../../services/typeTache.service';

@Component({
  selector: 'ngx-app-tache-item',
  templateUrl: './tache-item.component.html',
  styleUrls: ['./tache-item.component.scss']
})
export class TacheItemComponent implements OnInit {

  @Input() typeTache;
  @Input() taches;
  format = 'dd/MM/yyyy hh:mm';
  nextTaskIn: string;
  noIncomingTask: string;
  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.translate.get('NEXT_TASK_IN').subscribe((res: string) => {
      this.nextTaskIn = res;
    });
    this.translate.get('NO_INCOMING_TASK').subscribe((res: string) => {
      this.noIncomingTask = res;
    });
  }

}